// extracted by mini-css-extract-plugin
module.exports = {"smoothScrolling":"styles-module--smoothScrolling--3HtD6"};